import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import TruckLocation from "./Icon/truck.png";
import { Marker } from "@react-google-maps/api";
import { getLocationAndVehicleUsage } from "../../../../../../../actions/locationVehicle";
import Direction from "./Direction";
import siteService from "../../../../../../../services/site.service";

const MarkerDriver = (props) => {
  const dispatch = useDispatch();
  const [isLocationDriver, setLocationDriver] = useState([]);
  const [directions, setDirections] = useState(null);
  const locationVehicle = useSelector(
    (state) => state.locationVehicle
  );
  const truckIcon = {
    url: TruckLocation,
    scaledSize: new window.google.maps.Size(50, 40), // Size of the icon
    origin: new window.google.maps.Point(0, 0), // Origin point
    anchor: new window.google.maps.Point(25, 50), // Anchor point
  };

  useEffect(() => {
    if (props.inforInCar != null) {
      const updateLocationDriver = () => {
        const fetchData = async () => {
          try {
            // Fetch Location Driver Delivery Sample Shuttle
            if (props.typeOfBooking === "DeliverySampleShuttle") {
              await dispatch(
                getLocationAndVehicleUsage(props.inforInCar.idDriver)
              );
            }
            // Fetch Location Driver (Compatible with any type of booking)
            else {
              const result = await siteService.getLocationDriverById(
                props.inforInCar.idDriver
              );
              if (result.data.length > 0) {
                setLocationDriver([
                  {
                    Lat: result.data[0].lat,
                    Lng: result.data[0].lng,
                    lastUpdate: result.data[0].lastUpdate,
                  },
                ]);
                console.log("Fetch Driver Location Successfully");
              } else {
                console.log("Driver Location Not Found");
              }
            }
          } catch (error) {
            console.error("Error fetching data", error);
          }
        };

        if (
          props.typeOfBooking === "DeliverySampleShuttle" &&
          props.inforInCar.status === "รับสินค้าเรียบร้อย"
        ) {
          fetchData();
        } else if (
          props.typeOfBooking === "BetweenSiteCar" &&
          props.inforInCar.isFinish === 0
        ) {
          fetchData();
        }
      };
      updateLocationDriver();
    }
  }, [props.inforInCar, props.refresh]);

  // Only delivery sample shuttle use this
  useEffect(() => {
    if (
      locationVehicle &&
      locationVehicle.result?.length > 0
    ) {
      setLocationDriver([
        {
          Lat: locationVehicle.result[0].lat,
          Lng: locationVehicle.result[0].lng,
        },
      ]);
    } else {
      setLocationDriver([{ Lat: 0, Lng: 0 }]);
    }
  }, [locationVehicle]);

  useEffect(() => {
    const directionsService = new window.google.maps.DirectionsService();
    if (props.typeOfBooking === "DeliverySampleShuttle") {
      if (props.siteFrom != null && props.inforInCar) {
        if (
          props.inforInCar.status === "ส่งสินค้าเรียบร้อย" ||
          props.inforInCar.status === "ได้รับสินค้าเรียบร้อย" ||
          props.inforInCar.status === "รอรับสินค้า" ||
          (props.inforInCar.status === "รับสินค้าเรียบร้อย" &&
            locationVehicle.result?.length <= 0) ||
          (props.inforInCar.status === "รับสินค้าเรียบร้อย" &&
            locationVehicle.result?.length > 0 &&
            locationVehicle.result[0].endTime !== null)
        ) {
          directionsService.route(
            {
              origin: new window.google.maps.LatLng(
                props.siteTo.Lat,
                props.siteTo.Lng
              ),
              destination: new window.google.maps.LatLng(
                props.siteFrom.Lat,
                props.siteFrom.Lng
              ),
              travelMode: window.google.maps.TravelMode.DRIVING,
            },
            (result, status) => {
              if (status === window.google.maps.DirectionsStatus.OK) {
                setDirections(result);
              } else {
                console.error(`error fetching directions ${result}`);
              }
            }
          );
        } else if (
          props.inforInCar.status === "รับสินค้าเรียบร้อย" &&
          locationVehicle.result?.length > 0 &&
          locationVehicle.result[0].endTime === null &&
          isLocationDriver.length > 0 &&
          isLocationDriver[0].Lat &&
          isLocationDriver[0].Lng
        ) {
          directionsService.route(
            {
              origin: new window.google.maps.LatLng(
                isLocationDriver[0].Lat,
                isLocationDriver[0].Lng
              ),
              destination: new window.google.maps.LatLng(
                props.siteFrom.Lat,
                props.siteFrom.Lng
              ),
              waypoints: [
                {
                  location: new window.google.maps.LatLng(
                    props.siteTo.Lat,
                    props.siteTo.Lng
                  ),
                  stopover: true,
                },
              ],
              travelMode: window.google.maps.TravelMode.DRIVING,
            },
            (result, status) => {
              if (status === window.google.maps.DirectionsStatus.OK) {
                setDirections(result);
              } else {
                console.error(`error fetching directions ${result}`);
              }
            }
          );
        }
      }
    } else if (props.typeOfBooking === "BetweenSiteCar") {
      if (props.siteFrom && props.siteTo && props.inforInCar) {
        if (
          props.inforInCar.isFinish === 1 ||
          (props.inforInCar.isFinish === 0 && !props.inforInCar.idDriver)
        ) {
          directionsService.route(
            {
              origin: new window.google.maps.LatLng(
                props.siteTo.Lat,
                props.siteTo.Lng
              ),
              destination: new window.google.maps.LatLng(
                props.siteFrom.Lat,
                props.siteFrom.Lng
              ),
              travelMode: window.google.maps.TravelMode.DRIVING,
            },
            (result, status) => {
              if (status === window.google.maps.DirectionsStatus.OK) {
                setDirections(result);
              } else {
                console.error(`error fetching directions ${result}`);
              }
            }
          );
        } else if (
          props.inforInCar.isFinish === 0 &&
          isLocationDriver.length > 0 &&
          isLocationDriver[0].Lat &&
          isLocationDriver[0].Lng
        ) {
          directionsService.route(
            {
              origin: new window.google.maps.LatLng(
                isLocationDriver[0].Lat,
                isLocationDriver[0].Lng
              ),
              destination: new window.google.maps.LatLng(
                props.siteFrom.Lat,
                props.siteFrom.Lng
              ),
              waypoints: [
                {
                  location: new window.google.maps.LatLng(
                    props.siteTo.Lat,
                    props.siteTo.Lng
                  ),
                  stopover: true,
                },
              ],
              travelMode: window.google.maps.TravelMode.DRIVING,
            },
            (result, status) => {
              if (status === window.google.maps.DirectionsStatus.OK) {
                setDirections(result);
              } else {
                console.error(`error fetching directions ${result}`);
              }
            }
          );
        }
      }
    }
  }, [isLocationDriver]);

  const isDeliverySampleShuttle =
    props.typeOfBooking === "DeliverySampleShuttle" &&
    (props.inforInCar.status === "รอรับสินค้า" ||
      props.inforInCar.status === "รับสินค้าเรียบร้อย") &&
    isLocationDriver?.length > 0;

  const isBetweenSiteCar =
    props.typeOfBooking === "BetweenSiteCar" &&
    props.inforInCar.isFinish === 0 &&
    isLocationDriver?.length > 0;

  return (
    <>
      {(isDeliverySampleShuttle || isBetweenSiteCar) && (
        <Marker
          position={{
            lat: parseFloat(isLocationDriver[0].Lat),
            lng: parseFloat(isLocationDriver[0].Lng),
          }}
          icon={truckIcon}
        />
      )}
      {directions && (
        <Direction
          directions={directions}
          inforInCar={props.inforInCar}
          typeBooking={props.typeOfBooking}
        />
      )}
    </>
  );
};

export default MarkerDriver;
